import type { PlainAgentExecution } from "@/queries/agent-queries";
import { getDetailsURL } from "@/routes/environments/details-url";
import { Environment } from "gitpod-next-api/gitpod/v1/environment_pb";

export type Session = {
    id: string;
    environmentIds: string[];
    agentExecutionIds: string[];
};

export type SessionType = "standalone-agent-execution" | "standalone-environment" | "agent-execution-with-environments";

export function keyAgentExecutionSessionMapping(agentExecutionId: string): string {
    return `agent-execution-${agentExecutionId}-session-id`;
}

export function getSessionType(session: Session): SessionType {
    if (!session.agentExecutionIds && !session.environmentIds) {
        throw new Error("invalid session: must contain at least one environment id or agent execution id");
    }

    if (!session.agentExecutionIds.length) {
        return "standalone-environment";
    }

    if (!session.environmentIds.length) {
        return "standalone-agent-execution";
    }

    return "agent-execution-with-environments";
}

export function getSessionUrl(session?: Session): string {
    if (!session) {
        return "";
    }

    const type = getSessionType(session);
    switch (type) {
        case "agent-execution-with-environments":
        case "standalone-agent-execution":
            return `/ai/sessions/${session.id}`;
        case "standalone-environment":
            // TODO(mads): Hacky way to get the environment details url
            return getDetailsURL(new Environment({ id: session.environmentIds[0] }));
    }
}
export function usedEnvironmentIds(execution: PlainAgentExecution): string[] {
    const ids = new Set<string>();
    // Optimization: This will eventually show up in status.usedEnvironments, but that might take a while to propagate
    // so we'll use the codeContext.context.value to get the environmentId early.
    if (execution.spec?.codeContext?.context?.case === "environmentId") {
        ids.add(execution.spec.codeContext.context.value);
    }
    for (const { environmentId } of execution.status?.usedEnvironments ?? []) {
        ids.add(environmentId);
    }
    return Array.from(ids);
}
